import React, { Component } from 'react';
import { BrowserRouter, Route } from "react-router-dom";
import './App.css';
import '@progress/kendo-theme-default/dist/all.css';
import Layout from './Layout'
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { GoogleAuthProvider } from "firebase/auth";
import Login from './Pages/Login';
import { getAuth, onAuthStateChanged,getIdToken } from "firebase/auth";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD31kFbqxOZ0Qo8_x2pTHD1yI1PgFkOFzs",
  authDomain: "cecbpm-33900.firebaseapp.com",
  projectId: "cecbpm-33900",
  storageBucket: "cecbpm-33900.appspot.com",
  messagingSenderId: "886631643251",
  appId: "1:886631643251:web:ff00a0b0d37b6c279f5206",
  measurementId: "G-KWEE3NBR54"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const provider = new GoogleAuthProvider();

provider.addScope('https://www.googleapis.com/auth/contacts.readonly');

class App extends Component {
  render() {
    return (
      <BrowserRouter>
          <Layout />          
      </BrowserRouter>
    )
  }
}

export default App;